module.exports = __webpack_public_path__ + "static/img14-818dbababe6229a2bb045e6be4e393fa.jpg";